var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C8793",
    fillRule: "nonzero",
    d: "M35.938 40.625a2.344 2.344 0 1 1 .1 4.687 2.344 2.344 0 0 1-.101-4.687h.001zM37.5 37.5a1.563 1.563 0 0 1-3.125 0v-6.25a1.563 1.563 0 0 1 3.125 0v6.25zm9.15 6.287L37.847 26.18a2.133 2.133 0 0 0-3.817 0l-8.805 17.607a2.133 2.133 0 0 0 1.91 3.088h17.608a2.133 2.133 0 0 0 1.909-3.088h-.002zm2.566 3.719A5.258 5.258 0 0 1 44.742 50H27.134a5.258 5.258 0 0 1-4.704-7.611l8.803-17.606a5.258 5.258 0 0 1 9.408 0l8.804 17.605a5.258 5.258 0 0 1-.229 5.118zm-33.591-6.881a1.563 1.563 0 0 1 0 3.125H4.687A4.687 4.687 0 0 1 0 39.062V4.688A4.688 4.688 0 0 1 4.688 0h22.144c1.242 0 2.433.494 3.312 1.372l5.984 5.984a4.687 4.687 0 0 1 1.372 3.313v6.518a1.563 1.563 0 0 1-3.125 0V10.67c0-.414-.165-.811-.457-1.104l-5.983-5.983a1.562 1.562 0 0 0-1.104-.457H4.688c-.863 0-1.563.7-1.563 1.563v34.374c0 .863.7 1.563 1.563 1.563h10.937v-.001zm-4.688-30.469a2.344 2.344 0 1 1 .002 4.688 2.344 2.344 0 0 1-.002-4.688zm8.64 6.108a3.123 3.123 0 0 1 2.596-1.335c1.033.011 1.994.533 2.59 1.43l3.345 5.355a1.562 1.562 0 1 1-2.65 1.656l-3.32-5.315-4.167 5.94a1.562 1.562 0 0 1-2.256.322l-2.556-2.047-2.849 5.855h10.002a1.563 1.563 0 0 1 0 3.125h-12.5a1.562 1.562 0 0 1-1.405-2.246l4.036-8.294.105-.183a3.125 3.125 0 0 1 4.554-.705l1.267 1.015 3.208-4.573z",
    opacity: 0.352
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.b642899f.svg";
export { ForwardRef as ReactComponent };